import classNames from 'classnames'
import { memo, useState } from 'react'
import { DailyTasks } from './components/daily-task'
import { SpecialTasks } from './components/special-task'
// import { DailyTasks } from './components/daily-task'
// import { SpecialTasks } from './components/special-task'

export const Tasks = memo(() => {
  const [taskTypeSelected, setTaskTypeSelected] = useState('specialTask')

  return (
    <div className="w-screen h-screen flex flex-col flex-1 overflow-hidden px-4 pt-4 bg-cover bg-center bg-no-repeat relative ">
      <div
        className={classNames(
          'absolute top-0 left-0 w-full h-90 pointer-events-none z-0',
          taskTypeSelected === 'specialTask' &&
            'bg-gradient-to-b from-blue-500 via-pink-400  to-transparent',
          taskTypeSelected === 'diary' &&
            ' h-full bg-gradient-to-b from-orange-400 via-yellow-300 to-transparent',
        )}
      />

      <div className="absolute top-6 left-0 w-full flex justify-center z-30">
        <h1 className="text-white font-bold text-lg drop-shadow-md">
          Centro de Tarefas
        </h1>
      </div>

      <div className="flex flex-row w-full gap-4 items-center rounded-2xl p-2 bg-white/20 relative z-20 mt-12">
        <button
          className={classNames(
            'flex items-center justify-center rounded-2xl py-1 px-3 ',
            { 'opacity-80 text-white': taskTypeSelected !== 'specialTask' },
            { 'bg-white ': taskTypeSelected === 'specialTask' },
          )}
          onClick={() => setTaskTypeSelected('specialTask')}
        >
          <span className="text-xs font-bold">Special Task</span>
        </button>

        <button
          className={classNames(
            'flex items-center justify-center rounded-2xl py-1 px-3 ',
            { 'opacity-80 text-white': taskTypeSelected !== 'diary' },
            { 'bg-white ': taskTypeSelected === 'diary' },
          )}
          onClick={() => setTaskTypeSelected('diary')}
        >
          <span className="text-xs font-bold">Diário</span>
        </button>
      </div>

      {taskTypeSelected === 'specialTask' && (
        <div className="relative mt-2 w-full z-20">
          <div className="py-1 text-center text-xs text-yellow-900 font-semibold bg-gradient-to-r from-transparent-300 via-yellow-300 to-transparent-400 rounded-md">
            Taxa de câmbio atual: 💎 10,000 ≈ BRL 5.06
          </div>
        </div>
      )}

      <div className="flex flex-col overflow-y-scroll gap-2 pb-10 z-10">
        {taskTypeSelected === 'specialTask' && <SpecialTasks />}
        {taskTypeSelected === 'diary' && <DailyTasks />}
      </div>
    </div>
  )
})

Tasks.displayName = 'Tasks'
